import React, { useRef } from "react";
import { applyDateMask, brDateToISO, isoDateToBR } from "./dateUtils";

/* Campo de data: texto mascarado dd/mm/aaaa (digitável) + ícone de calendário
   que abre o date picker NATIVO do navegador. Um <input type="date"> fica
   sobreposto ao ícone (transparente): clicar nele abre o calendário; o
   showPicker() é chamado também como reforço. value/text trafegam em ISO e
   máscara; onChange devolve (iso|null, masked). */
const CalIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
);

const DateField = ({ label, value, text, onChange, placeholder = "dd/mm/aaaa" }) => {
  const nativeRef = useRef(null);

  const handleText = (e) => {
    const masked = applyDateMask(e.target.value);
    const iso = masked.length === 10 ? brDateToISO(masked) : null;
    onChange(iso, masked);
  };

  const handleNative = (e) => {
    const iso = e.target.value; // yyyy-mm-dd
    onChange(iso || null, iso ? isoDateToBR(iso) : "");
  };

  const openPicker = () => {
    const el = nativeRef.current;
    if (!el) return;
    if (typeof el.showPicker === "function") {
      try {
        el.showPicker();
        return;
      } catch (_e) {
        /* fora de user-gesture ou não suportado — cai no overlay/focus */
      }
    }
    el.focus();
  };

  return (
    <div className="field">
      {label && <label>{label}</label>}
      <div className="input date-input">
        <input
          className="masked"
          value={text}
          onChange={handleText}
          placeholder={placeholder}
          inputMode="numeric"
        />
        <button
          type="button"
          className="cal-wrap"
          onClick={openPicker}
          aria-label={label}
          tabIndex={-1}
        >
          <CalIcon />
          <input
            ref={nativeRef}
            type="date"
            className="native-date"
            value={value || ""}
            onChange={handleNative}
            tabIndex={-1}
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  );
};

export default DateField;
